import { useEffect } from 'react';

import {
  BeforeInstallPromptEvent,
  usePwaStore,
} from '../stores/usePwaStore';

declare global {
  interface Navigator {
    standalone?: boolean;
  }

  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

export function usePwaInstallListener(isEnabled = true) {
  const setInstallPromptEvent = usePwaStore((s) => s.setInstallPromptEvent);
  const setIsInstallable = usePwaStore((s) => s.setIsInstallable);
  const setIsInstalled = usePwaStore((s) => s.setIsInstalled);

  useEffect(() => {
    if (!isEnabled) {
      setInstallPromptEvent(null);
      setIsInstallable(false);
      setIsInstalled(false);
      return;
    }

    // Detect if already running as installed PWA
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    if (isStandalone) {
      setIsInstalled(true);
      return;
    }

    const handleBeforeInstallPrompt = (event: BeforeInstallPromptEvent) => {
      event.preventDefault();
      setInstallPromptEvent(event);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      setInstallPromptEvent(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      );
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, [isEnabled, setInstallPromptEvent, setIsInstallable, setIsInstalled]);
}
